<template>
  <div id="stop-menu-content">
    <!-- fare -->
    <div class="row stop-menu-row">
      <div class="bus-fare">
                <span class="bus-fare-logo">
                    <img src="../../assets/price.png">
                </span>
        <span class="bus-fare-value">
                    車費: ${{ stopDetails.fare }}
                </span>
      </div>
    </div>

    <!-- ETA -->
    <div class="row">
      <Eta :etaData="stopEta"></Eta>
    </div>

    <!-- more -->
    <div class="row">
      <div class="more-stop-details">
        <a v-if="!moreDetails" href='javascript:void(0)' @click="showMoreDetails()">更多...</a>
      </div>
    </div>
    <div class="clear"></div>

    <!-- more stop details -->
    <div v-if="moreDetails" class="row">
      <!-- <p>More stop details here...</p> -->
      <StopMenuBottom></StopMenuBottom>
    </div>


  </div>
</template>

<script>
import Eta from '../Eta/Eta';
import StopMenuBottom from './StopMenuBottom';

import {mapMutations, mapState} from 'vuex';
import etaParse from "../../utils/etaParse";

export default {
  name: "StopMenuContent",
  components: {
    Eta, StopMenuBottom,
  },
  computed: {
    ...mapState('stopMenu', ['stopDetails', 'moreDetails']),
    stopEta() {
      const {company} = this.stopDetails;

      if (this.stopDetails.eta) {
        console.log('stop details', this.stopDetails);

        return etaParse(company, this.stopDetails.eta);
      }

      return [];
    },
  },
  methods: {
    ...mapMutations('stopMenu', ['showMoreDetails']),

  },
  mounted() {
  },
}
</script>

<style scoped>
.bus-fare {
  margin-bottom: 8px;
}

.more-stop-details {
  color: blue;
  text-decoration: underline;
  position: absolute;
  right: 12px;
  bottom: 8px;
}

.bus-fare-logo {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}

.bus-fare > span {
  vertical-align: bottom;
  display: inline-block;
  height: 16px;
}

.bus-fare img {
  vertical-align: baseline;
}
</style>
